import { Flex, Text, useBreakpointValue } from "@chakra-ui/react";

interface HeaderProps {
	title: string;
	subtitle?: string;
	// "sm" for subsections under a page title (e.g. on the Resources page)
	size?: "md" | "sm";
}

export default function SectionHeader({ title, subtitle, size = "md" }: HeaderProps) {
    
    const titleFontSize = useBreakpointValue(
        size === "sm"
            ? { base: "24px", md: "28px" }
            : { base: "32px", md: "36px", lg: "40px" }
    );
	const subtitleFontSize = useBreakpointValue(
        size === "sm"
            ? { base: "16px" }
            : { base: "18px", md: "18px", lg: "18px" }
    );

	return (
		<Flex
            flexDirection={"column"}
            margin={"auto"}
            width={"80%"}
        >
            <Text
                textAlign={"center"}
                fontFamily={"Martel"}
                fontWeight={"700"}
                fontSize={titleFontSize}
                color={"white.500"}
            >
                {title}
            </Text>

            {subtitle && (
                <Text
                    textAlign={"center"}
                    fontFamily={"Montserrat"}
                    fontWeight={"500"}
                    fontSize={subtitleFontSize}
                    color={"white.500"}
                >
                    {subtitle}
                </Text>
            )}
        </Flex>
	);
};
